import * as React from 'react'

import { Box, Icon, MediumIcon, Tooltip, useToggle } from '@factorialco/deprecated-design-system'

interface SelectorOptionProps {
  selectedValue: string
  value: string
  icon: MediumIcon
  label: string
  onChange: (value: string) => void
}

const SelectorOption = ({ selectedValue, value, icon, label, onChange }: SelectorOptionProps) => {
  const [open, toggle] = useToggle(false)

  return (
    <Tooltip.Alt attachment="top center" open={open} toggle={toggle} label={label} inline>
      <Box onClick={() => onChange(value)}>
        <Icon.Medium color={value == selectedValue ? 'grey1000' : 'grey600'} icon={icon} />
      </Box>
    </Tooltip.Alt>
  )
}

export default SelectorOption
